import { unpack } from '@/legacy/lib//util';
import Model from '@/legacy/lib//Model';

export default class PickerTree extends Model
{
  constructor (props)
  {
    super ();

    this.labels   = [];
    this.nodes    = {};
    this.defaults = {};
  }

  add (obj)
  {
    let key;
    let value;
    let prev;
    let ptr;
    let level;

    ptr = this.nodes;
    level = 0;

    for (key of Object.keys (obj)) {
      this.labels [level++] = key;

      value = obj [key];

      if (! (value in ptr)) {
        ptr [value] = {};
      }

      prev = ptr;
      ptr = ptr [value];
    }

    prev [value] = null;
  }

  getDefault ()
  {
    let res = {};
    let ptr = this.nodes;

    for (let label of this.labels) {
      if (
        label in this.defaults &&
        this.defaults [label] in ptr
      ) {
        res [label] = this.defaults [label];
      } else {
        let keys = Object.keys (ptr);
        let key = keys [0];

        if (label === 'season') key = keys [keys.length - 1];
        res [label] = key;
      }

      ptr = ptr [res [label]];
    }

    return res;
  }

  setDefaults (defaults)
  {
    for (let key in defaults) {
      this.defaults [key] = defaults [key];
    }
  }

  meshes (obj)
  {
    console.log (JSON.stringify (obj));
    let ptr = this.nodes;

    for (let value of Object.values (obj)) {
      if (ptr == null) {
        return false;
      }

      if (! (value in ptr)) {
        return false;
      }

      ptr = ptr [value];
    }

    return true;
  }
}
